import { Component, ElementRef, forwardRef, Input, OnInit, SimpleChanges, ViewChild } from '@angular/core'
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms'

@Component({
  selector: 'rpo-range-slider',
  templateUrl: './rpo-range-slider.component.html',
  styleUrls: ['./rpo-range-slider.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => RpoRangeSliderComponent),
      multi: true,
    },
  ],
  standalone: false,
})
export class RpoRangeSliderComponent implements OnInit, ControlValueAccessor {
  // Note: this list needs to be sorted from shortest to longest RPO
  rpoOptions = [
    // in seconds
    { val: 60 * 15, text: '15 mins' },
    { val: 60 * 30, text: '30 mins' },
    { val: 60 * 60, text: '60 mins' },
    { val: 60 * 90, text: '90 mins' },
    { val: 60 * 60 * 2, text: '2 hours' },
    { val: 60 * 60 * 4, text: '4 hours' },
    { val: 60 * 60 * 8, text: '8 hours' },
    { val: 60 * 60 * 12, text: '12 hours' },
    { val: 60 * 60 * 24, text: '24 hours' },
  ]

  private _value: number = null
  @ViewChild('rangeControl', { static: true }) rangeControl: ElementRef
  @Input() enableRealTimeRpos: boolean = false

  private _controlChangeFunction: any = null

  constructor() {}

  ngOnInit(): void {}

  ngOnChanges(changes: SimpleChanges) {
    // If enabled for real time RPOs, add that option into the list.
    if (this.enableRealTimeRpos) {
      this.rpoOptions.push({ val: 0, text: 'Real-time replication' })
    }
    this.rpoOptions.sort((l, r) => l.val - r.val)
  }

  get currentOptionIndex() {
    return Math.max(
      this.rpoOptions.findIndex((option) => option.val >= this._value),
      0
    )
  }

  get currentValueText() {
    return this.rpoOptions[this.currentOptionIndex].text
  }

  sliderChange() {
    this._value = this.rpoOptions[parseInt(this.rangeControl.nativeElement.value)].val
    if (this._controlChangeFunction) {
      this._controlChangeFunction(`${this._value}`)
    }
  }

  writeValue(value: number): void {
    this._value = value
  }

  registerOnChange(fn: any): void {
    this._controlChangeFunction = fn
  }

  registerOnTouched(fn: any): void {}
}
